import { css } from 'styled-components';

import { rem } from 'approot/shared/style';

export const viewportMaxCss = css`
  max-width: ${rem(800)};
  margin: auto;
`;

export const viewport16by9Ratio = css`
  padding-top: 56.25%;
  position: relative;
`;
